// extracted by mini-css-extract-plugin
export default {"email-button":"EmailButton--email-button--EJuHg","emailButton":"EmailButton--email-button--EJuHg"};